import Module from './Module';

const module = new Module('reports', '/api/v1/reports');

export const {
  get, getById, resetState, remove
} = module;

export default module.reducer;



// WEBPACK FOOTER //
// ./src/modules/reports.js